module.exports = "https://web-assets.ifttt.com/packs/media/solutions_by_industry/fintech-c05bb124.svg";